import { memo } from 'react'

import { useNavigate, ParsePathParams } from '@tanstack/react-router'

import { SnackPanelActions, SnackPanelActionsProps, ViewSpace } from '@shared/components/Snackbar'
import { useHotkeys } from '@shared/utils/hooks'
import { SnackPanelActionButtonLink } from 'components/LinkedMUIComponents'
import { videoObjectRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object'

type SuccessPanelActionsProps = Record<ParsePathParams<typeof videoObjectRoute.fullPath>, string>

const SuccessPanelActionsRaw = ({
  onClose,
  buttonDefaultProps: _,
  ...routeParams
}: SuccessPanelActionsProps & SnackPanelActionsProps) => {
  const navigate = useNavigate()

  useHotkeys([
    [
      'space',
      () => {
        navigate({ to: videoObjectRoute.to, params: routeParams })
        onClose()
      },
    ],
  ])

  return (
    <SnackPanelActions>
      <SnackPanelActionButtonLink to={videoObjectRoute.to} params={routeParams} onClick={() => onClose()}>
        <ViewSpace />
      </SnackPanelActionButtonLink>
    </SnackPanelActions>
  )
}

export const SuccessPanelActions = memo(SuccessPanelActionsRaw)
